import React from 'react';

import { Stack, Text } from '@mantine/core';
import cx from 'classnames';

import formatDate from '@/utils/formatDate';
import { routes } from '@/routes';

import { PatientData } from '@/types/patientList';

import styles from './cells.module.scss';

interface PatientCellProps {
  patient: PatientData;
}

export const PatientCell: React.FC<PatientCellProps> = ({ patient }) => {
  const handlePatientNameClick = () => {
    if (patient.id) {
      const patientProfileUrl = `${routes.physician.patients}/${patient.id}`;
      window.open(patientProfileUrl, '_blank', 'noopener,noreferrer');
    }
  };

  const trimmedName = patient.name?.trim();
  const displayName = trimmedName || '-';

  return (
    <Stack gap={2}>
      <Text
        className={cx(styles.patientName, styles.cellText, styles.clickablePatientName)}
        onClick={handlePatientNameClick}>
        {displayName}
      </Text>
      <Text className={styles.subText} unstyled>
        DOB: {formatDate(patient.dob, 'MM-DD-YYYY')} / MRN: {patient.mrn || 'N/A'}
      </Text>
    </Stack>
  );
};
